module.exports = __webpack_public_path__ + "static/media/file-alt.1f92dcad.svg";